/** @jsx jsx */

import React from "react";
import { Button } from "antd";
import { css, jsx, SerializedStyles } from "@emotion/core";

import { ButtonProps } from "antd/es/button";
import { color, fonts, breakpoints } from "../../theme/Theme";

interface Props extends ButtonProps {
  containerDivStyle?: SerializedStyles;
  containerDivClassName?: string;
}

/**
 *  Creates button with type specified, accepts all the Button ant design props
 *  along with custom props. Styles the button with a predefined stylesheet
 *  consistent with buttons across application
 */

const CustomButton: React.FC<Props> = ({
  children,
  type,
  size,
  containerDivClassName,
  containerDivStyle,
  className,
  ...restProps
}: Props) => {
  return (
    <div
      css={[buttonStyles, containerDivStyle]}
      className={`d-flex ${containerDivClassName || ""}`}
    >
      <Button
        type={type}
        size={size || "large"}
        className={`
        ${
          size
            ? size === "small"
              ? "px-3"
              : size === "default"
              ? "px-4"
              : "px-5"
            : "px-5"
        }
        ${!type || type === "default" ? "default-btn " : ""}${className || ""}`}
        {...restProps}
      >
        {children}
      </Button>
    </div>
  );
};

const buttonStyles = css({
  fontFamily: fonts.bold,
  button: {
    borderColor: color.primary
  },
  ".default-btn": {
    color: color.primary
  },
  ".ant-btn[disabled]": {
    color: color.primary,
    opacity: "50%",
    borderColor: color.primary
  },
  ".ant-btn-primary": {
    background: color.primary
  },
  ".ant-btn-primary[disabled]": {
    color: color.white,
    opacity: "50%",
    backgroundColor: color.primary
  },

  [`@media screen and (max-width: ${breakpoints.md})`]: {
    button: {
      width: "100%"
    }
  }
});

export default CustomButton;
